var _path, _circle, _circle2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4307 10.7504C12.4305 11.189 12.2561 11.6096 11.9458 11.9196C11.6354 12.2296 11.2147 12.4036 10.7761 12.4034C10.3374 12.4032 9.91686 12.2287 9.60686 11.9184C9.29686 11.6081 9.12283 11.1873 9.12305 10.7487C9.12327 10.3101 9.29772 9.88952 9.60803 9.57952C9.91834 9.26952 10.3391 9.09548 10.7777 9.0957C11.2163 9.09592 11.6369 9.27038 11.9469 9.58069C12.2569 9.891 12.431 10.3117 12.4307 10.7504ZM12.4804 13.6281H9.17266V23.9811H12.4804V13.6281ZM17.7065 13.6281H14.4154V23.9811H17.6734V18.5483C17.6734 15.5217 21.6179 15.2406 21.6179 18.5483V23.9811H24.8842V17.4236C24.8842 12.3215 19.0461 12.5117 17.6734 15.0173L17.7065 13.6281Z",
    fill: "#8E8E8E"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.6146,
    cy: 16.5385,
    r: 16.5385,
    fill: "#6C6C6C",
    fillOpacity: 0.39
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.6146,
    cy: 16.5385,
    r: 16.125,
    stroke: "#8E8E8E",
    strokeOpacity: 0.31,
    strokeWidth: 0.826923
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.6c6590495b525698397b0c6d8509f859.svg";
export { ForwardRef as ReactComponent };